import React, { useEffect, useState } from 'react';
import Datetime from "react-datetime";
import moment, { Moment } from 'moment';

interface TimePickerProps {
  selectedTime: string | null;
  onChange: (time: Moment) => void;
}

const TimePicker: React.FC<TimePickerProps> = ({ selectedTime, onChange }) => {
  const [time, setTime] = useState<moment.Moment>(moment());

  const handleTimeChange = (value: Moment | string) => {
    if (moment.isMoment(value)) {
      onChange(value);
    }
  };
  useEffect(() => {
    if (selectedTime) {
      setTime(moment(selectedTime));
    }
  }, [selectedTime]);

  const timeConstraints = {
    hours: { min: 1, max: 12, step: 1 },
    minutes: { min: 0, max: 59, step: 1 },
    seconds: { min: 0, max: 0, step: 1 },
  };

  return (
    <>
      <div className="form-group">
        <Datetime
          input={false}
          value={time}
          dateFormat={false}
          timeConstraints={timeConstraints}
          onChange={handleTimeChange}
        />
      </div>
    </>
  );
}

export default TimePicker;